import { Outlet, useNavigate } from 'react-router';
import MainLayout from './layouts/MainLayout';
import { ModalProvider } from '../contexts/ModalContext';
import { useEffect } from 'react';
import usePermissions from '../hooks/usePermissions';
import { getDefaultRoute } from '../constants/keycloak';
import { useMarketplace } from '../hooks/useMarketplace';

const Root = () => {
  const navigate = useNavigate();
  const { role } = usePermissions();
  const { isStandaloneCasino, isSuccess } = useMarketplace();

  const currentRoute = window.location.pathname;

  useEffect(() => {
    // Only navigate when we have successfully loaded the marketplace config
    if (currentRoute === '/' && isSuccess) {
      const route = getDefaultRoute(role, isStandaloneCasino);

      if (route) navigate(route);
    }
  }, [role, navigate, currentRoute, isStandaloneCasino, isSuccess]);

  return (
    <MainLayout>
      <ModalProvider>
        <Outlet />
      </ModalProvider>
    </MainLayout>
  );
};

export default Root;
